import { getCloudMigrationInfo } from '@atlassian/mpac-api-client';
import { hooks, log } from '@atlassian/mpac-utils';
import { useEffect } from 'react';

import type { CloudMigration } from '@atlassian/mpac-api-client';
import type { AppListingCloudMigration } from '@atlassian/mpac-types';

const { usePromise } = hooks;

const useCloudMigrationInfo = (mpacBaseUrl: string, appKey: string): AppListingCloudMigration => {
  const { result, error, pending } = usePromise<CloudMigration | null | undefined>(() =>
    getCloudMigrationInfo(mpacBaseUrl, appKey)
  );

  useEffect(() => {
    if (error) {
      log.error('Cloud migration status check', 'Failed to retrieve cloud migration status', {
        error,
        variables: { appKey },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return {
    pending,
    appKey,
    alternateCloudAppKey: appKey === result?.cloudAddonKey ? null : result?.cloudAddonKey,
    featureDifferenceDocumentation: result?.featureDifferenceDocumentation,
    migrationDocumentation: result?.migrationDocumentation,
  };
};

export default useCloudMigrationInfo;
